import React from 'react';
import Delete from '@src/components/wysiwyg_editor/page_content_items/control_panels/Delete';
import { useDispatch } from 'react-redux';
import { deletePageContentItem, saveSnapshot } from '@src/actions/wysiwyg/editor';

import ButtonList from '@src/components/wysiwyg_editor/page_content_items/control_panels/ButtonList';

type TProps = {
  itemId: string;
};

function PreContentPanel({ itemId }: TProps) {
  const dispatch = useDispatch();

  return (
    <ButtonList>
      <Delete
        onClick={() => {
          dispatch(saveSnapshot());
          dispatch(deletePageContentItem(itemId));
        }}
      />
    </ButtonList>
  );
}

export default PreContentPanel;
